<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>Dennis, Cristian and David, your unconditional love is the tapestry of my creativity, inspiration, and imagination. Your encouragement and support will remain the light and main guidance to everything that I have achieved so far in my life. I can never express enough gratitude and love that I have for you all.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?310e7298